import { makeRequest } from 'utils/requestLogger';

export default () => makeRequest('post', '/api/users/track-active-time');



// WEBPACK FOOTER //
// ./src/app/services/account/trackActiveTime.js